import block from "bem-css-modules";
import {useController} from "react-hook-form";
import {useTranslation} from "react-i18next";

import s from './NumberInput.module.scss';
import RadioGroup from "./RadioGroup";
import {useEffect, useState} from "react";
import classNames from "classnames";
import {useFormatFee} from "../Hooks/useFormatFee";
import {useMethodData} from "../Hooks/useMethodData";
import {useDataFromHash} from "../Hooks/useDataFromHash";

const b = block(s);

const NumberWithCurrencyInput = ({control, name, watchPaymentMethod, type = 'number'}) => {
    const {
        field: {onChange, onBlur},
        fieldState: {error},
    } = useController({
        name,
        control,
        rules: {required: true},
    })

    const {amount: amountHash} = useDataFromHash();

    const [amount, setAmount] = useState( '');
    const {currency} = useMethodData(watchPaymentMethod);

    useEffect(() => {
        if (!isNaN(amountHash)) {
            setAmount(amountHash);
        }
    }, [amountHash])

    const invalid = error?.type !== undefined;
    const {t} = useTranslation('common');

    const {feeFormatted, totalAmountFormatted} = useFormatFee(watchPaymentMethod, amount);

    const handleNumbers = (value) => {
        setAmount(value);
        if (value) {
            const amountValue = value.replace(/[^0-9.]/g, '');
            onChange(amountValue);
        }
    }

    const presets = ['10', '18','30', '50'].map(id => {
        return {id, label: `${id} ${currency}`}
    })

    return <div>
        <div className={b('input-wrapper')}>
            <RadioGroup
                onChange={(e) => handleNumbers(e.target.value)}
                value={amount}
                items={presets}
                name="amount"
                defaultFirst={false}/>
            <div className={b('wrapper', {invalid})}>
                <div className={b('input-wrapper')}>
                    <input
                        type='number'
                        placeholder={t(name)}
                        onBlur={onBlur}
                        name={name}
                        value={amount}
                        id={`field-${name}`}
                        onChange={e => {
                            handleNumbers(e.target.value)
                        }}
                        className={b('input', {invalid})}/>
                    <label className={b('label', {invalid})} htmlFor={`field-${name}`}>{t(name)}</label>
                </div>
                {currency && <span className={classNames(b('currency'), "group-addon")}>{currency}</span>}
            </div>
        </div>
        <div className={b('messages')}>
            {feeFormatted && <span className={b('fee')}>{t('fee')}: {feeFormatted}.</span>}
            {totalAmountFormatted && <span className={b('fee')}>{t('total')}: {totalAmountFormatted}.</span>}
        </div>
        {invalid && <span className={b('error', {invalid})}>{invalid ? error?.message : ""}</span>}
    </div>
}

export default NumberWithCurrencyInput
